import {
    GET_OPENING_BALANCES,
    CREATE_OPENING_BALANCE,
    UPDATE_OPENING_BALANCE,
    DELETE_OPENING_BALANCE,
    BULK_UPLOAD_OPENING_BALANCES
} from '../../index.types';

// Get All Opening Balances
export const getOpeningBalances = (data) => ({
    type: GET_OPENING_BALANCES,
    data
});

// Create Opening Balance
export const createOpeningBalance = (data) => ({
    type: CREATE_OPENING_BALANCE,
    data
});

// Update Opening Balance
export const updateOpeningBalance = (data) => ({
    type: UPDATE_OPENING_BALANCE,
    data
});

// Delete Opening Balance
export const deleteOpeningBalance = (data) => ({
    type: DELETE_OPENING_BALANCE,
    data
});

// Bulk Upload Opening Balances
export const bulkUploadOpeningBalances = (data) => ({
    type: BULK_UPLOAD_OPENING_BALANCES,
    data
});
